import api from './api';
import { DocumentRecord, DocumentKind, TransactionCandidate, DocumentDetailsRequest, DocumentUploadResult } from '../types';

export interface DocumentFilter {
  kind?: DocumentKind;
  /** Nur Belege, die noch keinem Umsatz zugeordnet sind. */
  unmatched?: boolean;
  from?: string;
  to?: string;
  search?: string;
  transactionId?: number;
  limit?: number;
}

export const documentService = {
  getDocuments: async (filter: DocumentFilter = {}): Promise<DocumentRecord[]> => {
    const response = await api.get('/documents', { params: filter });
    return response.data;
  },

  /** Dokument hochladen; ohne `kind` ein Beleg. Mit `transactionId` hängt es gleich an diesem Umsatz. */
  upload: async (file: File, details: DocumentDetailsRequest = {}, transactionId?: number): Promise<DocumentUploadResult> => {
    const form = new FormData();
    form.append('file', file);
    Object.entries(details).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') form.append(key, String(value));
    });
    if (transactionId) form.append('transactionId', String(transactionId));
    const response = await api.post('/documents', form, { headers: { 'Content-Type': 'multipart/form-data' } });
    return response.data;
  },

  update: async (id: number, data: DocumentDetailsRequest): Promise<DocumentRecord> => {
    const response = await api.put(`/documents/${id}`, data);
    return response.data;
  },

  /** Die archivierte Datei als Blob - über die API, damit der Token mitgeht. */
  getFile: async (id: number): Promise<Blob> => {
    const response = await api.get(`/documents/${id}/file`, { responseType: 'blob' });
    return response.data;
  },

  getCandidates: async (id: number): Promise<TransactionCandidate[]> => {
    const response = await api.get(`/documents/${id}/candidates`);
    return response.data;
  },

  match: async (id: number, transactionId: number): Promise<DocumentRecord> => {
    const response = await api.put(`/documents/${id}/match`, { transactionId });
    return response.data;
  },

  unmatch: async (id: number): Promise<DocumentRecord> => {
    const response = await api.delete(`/documents/${id}/match`);
    return response.data;
  },

  /** Verwerfen (Fehlscan) - die Datei bleibt archiviert. */
  discard: async (id: number): Promise<void> => {
    await api.delete(`/documents/${id}`);
  },
};

export default documentService;
